"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Buffer = void 0;
const flow_connect_1 = require("flow-connect");
const core_1 = require("flow-connect/core");
const ui_1 = require("flow-connect/ui");
class Buffer extends core_1.Node {
    constructor() {
        super();
        this.buffer = [];
    }
    setupIO() {
        this.addTerminals([
            { type: flow_connect_1.TerminalType.IN, name: "data", dataType: "any" },
            { type: flow_connect_1.TerminalType.OUT, name: "buffer", dataType: "array" },
        ]);
    }
    created(options) {
        const { width = 150, name = "Buffer", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.state = Object.assign(Object.assign({ size: 10 }, options.state), state);
        this.setupUI();
        this.setupListeners();
    }
    process(inputs) {
        if (inputs[0] === null || typeof inputs[0] === "undefined")
            return;
        const size = (0, flow_connect_1.clampMin)(this.state.size, 1);
        if (this.buffer.length === size) {
            this.buffer.shift();
        }
        else if (this.buffer.length > size) {
            this.buffer.splice(0, this.buffer.length - size + 1);
        }
        this.buffer.push(inputs[0]);
        this.setOutputs("buffer", this.buffer);
    }
    setupUI() {
        this.sizeInput = this.createUI("core/input", {
            propName: "size",
            input: true,
            output: true,
            height: 20,
            style: { type: ui_1.InputType.Number, grow: 0.7 },
        });
        this.ui.append(this.createUI("core/x-layout", {
            childs: [this.createUI("core/label", { text: "Size", style: { grow: 0.3 } }), this.sizeInput],
            style: { spacing: 20 },
        }));
    }
    setupListeners() {
        this.watch("size", () => this.process(this.getInputs()));
    }
}
exports.Buffer = Buffer;
